import React from "react";

const Error=()=>
{
    return(
        <>
        <p>No page found</p>
        </>
    )
}

export default Error;